<script lang="ts">
  import { onMount } from "svelte";

  interface Props {
    duration?: number;
    repeat?: number;
    paused?: boolean;
    pauseOnHover?: boolean;
    children?: import('svelte').Snippet;
  }

  let {
    duration = 15,
    repeat = 2,
    paused = false,
    pauseOnHover = false,
    children
  }: Props = $props();

  let hovered = $state(false);
  let container: HTMLElement = $state()

  onMount(async () => {
    container.onmouseover  = () => { hovered = true }
    container.onmouseleave = () => { hovered = false }
  })
</script>


<div style="overflow: hidden;">
  <div bind:this={container} class="content" class:paused={paused || (pauseOnHover && hovered)}>
    {#each Array(repeat) as _, i}
      <div class="text" style="animation-duration: {duration}s">
        {@render children?.()}
      </div>
    {/each}
  </div>
</div>


<style lang="scss">
  .content {
    width: 100000px;
  }
  .text {
    display: flex;
    align-items: center;
    animation-name: animation;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    float: left;
  }
  .paused .text {
    animation-play-state: paused;
  }
  @keyframes animation {
    100% {
      transform: translateX(-100%);
    }
  }
</style>